import { createSlice } from "@reduxjs/toolkit";

export const tilesInternalSlugSlice = createSlice({
  name: "tiles_internal",
  initialState: {
    beSlug: "",
  },
  reducers: {
    setTilesData: (state, action) => {
      console.log("action api Data", action.payload, state);
      return { ...state, ...action.payload };
    },
    // reducers: {
    //   setHeaderData: (state, action) => {
    //       state = action.payload,
    //           console.log('action api Data', action.payload);
    //   }
  },
});

export const { setTilesData } = tilesInternalSlugSlice.actions;
export default tilesInternalSlugSlice.reducer;
